<template>
  <div class="common-ad">
    <div class="header-tool">
      <div class="header-tool-info">
        <Breadcrumb>
          <BreadcrumbItem>首页</BreadcrumbItem>
          <BreadcrumbItem>通用设置</BreadcrumbItem>
          <BreadcrumbItem>省市设置</BreadcrumbItem>
        </Breadcrumb>
        <div class="header-tool-title">省市设置</div>
      </div>
      <div class="header-tool-box">
        <div class="htb-item" @click="showAdd()">
          <span>添加省级</span>
        </div>
      </div>
    </div>
    <div class="my-item">
      <div class="custom-wrap">
        <template v-if="list && list.length">
          <Table :border="false" :columns="columns1" :load-data="handleLoadData" :data="list" row-key="id" :disabled-hover="false">
            <template slot-scope="{ row, index }" slot="name">
              <span class="brand">{{row.name}}</span>
            </template>
            <template slot-scope="{ row, index }" slot="shortname">
              <span class="brand">{{row.shortname}}</span>
            </template>
            <template slot-scope="{ row, index }" slot="showIndex">{{row.showIndex}}</template>
            <template slot-scope="{ row, index }" slot="action">
              <span style="color: #1890ff;cursor: pointer;" @click="editShow(row)">编辑</span>
              <span style="display: inline-block;padding: 0 5px;">|</span>
              <span
                style="color: #1890ff;cursor: pointer;"
                @click="editSubShow(row)"
                v-if="row.type === 1"
              >添加市级</span>
              <span
                style="display: inline-block;padding: 0 5px;"
                v-if="row.type === 1"
              >|</span>
              <span
                style="color: #1890ff;cursor: pointer;"
                @click="editSubShow2(row)"
                v-if="row.type === 2"
              >添加区/县级</span>
              <span
                style="display: inline-block;padding: 0 5px;"
                v-if="row.type === 2"
              >|</span>
              <Poptip confirm title="确认是否删除?" @on-ok="delItem(row)" :transfer="true">
                <span style="color: #f00;cursor: pointer;">删除</span>
              </Poptip>
            </template>
          </Table>
        </template>
        <div class="u-empty" v-else>暂无数据</div>
      </div>

      <cityAdd
        :show="show"
        @finish="init()"
        @close="show=false;"
        :options="options"
        :modelTitle="modelTitle"
      />
      <cityAddChild
        :show="showChild"
        @finish="init()"
        @close="showChild=false;"
        :options="optionsChild"
        :modelTitle="modelTitle"
      />
      <cityAddChild2
        :show="showChild2"
        @finish="init()"
        @close="showChild2=false;"
        :options="optionsChild2"
        :modelTitle="modelTitle"
      />
    </div>

  </div>
</template>

<script>
import cityAdd from "../components/city-add.vue";
import cityAddChild from "../components/city-child-add.vue";
import cityAddChild2 from "../components/city-child-add2.vue";
import { mapActions } from "vuex";

export default {
  // 主办设置
  name: "host-set",
  data() {
    return {
      list: null, 
      edit: false,
      editInfo: false,
      show: false, 
      options:{}, 
      modelTitle:'',
      columns1: [
        {
          title: "中文名称",
          key: "name",
          tree: true,
        },
        {
          title: "简称",
          slot: "shortname",
          key: "shortname",
          align: "center"
        },
        {
          title: "排序",
          slot: "showIndex",
          key: "showIndex",
          align: "center"
        },
        {
          title: "操作",
          slot: "action",
          align: "center"
        }
      ],
      showChild: false,
      showChild2: false,
      optionsChild:{},
      optionsChild2:{},
      showRecord: [], // 记录表格点开的行
    };
  },
  computed: {
    exhibitionInfo() {
      if (JSON.parse(localStorage.vuex)) {
        return JSON.parse(localStorage.vuex).hostSetModule.hostExhibition;
      }
    },
  },
  watch: {
    list: {
      handler:function(val) {
        val.map(c => {
          // 添加
          if (c._showChildren && this.showRecord.indexOf(c.id) === -1) {
            this.showRecord.push(c.id);
          }
          if (c.children && c.children.length > 0) {
            c.children.map(d => {
              if (d._showChildren && this.showRecord.indexOf(d.id) === -1) {
                this.showRecord.push(d.id);
              }
            })
          }
          // 移除
          if (!c._showChildren && this.showRecord.indexOf(c.id) !== -1) {
            let num = this.showRecord.indexOf(c.id);
            this.showRecord.splice(num,1);
          }
          if (c.children && c.children.length > 0) {
            c.children.map(d => {
              if (!d._showChildren && this.showRecord.indexOf(d.id) !== -1) {
                let num2 = this.showRecord.indexOf(d.id);
                this.showRecord.splice(num2,1);
              }
            })
          }
        })
      },
      deep: true
    }
  },
  created() {
    this.init();
  },
  components: {
    cityAdd,
    cityAddChild,
    cityAddChild2,
  },
  methods: {
    ...mapActions({
      getCity:'hostSetModule/getCity',
      getCity2:'hostSetModule/getCity2',
      delCity:'hostSetModule/delCity',
    }),  
    async init() {
      let listData = await this.getCity2("2710E818-5B91-4AA2-BCAD-0EF42A3DD6FD");
      if (listData && listData.length > 0) {
        listData.map(c => {
          // 若存在，展开对应的行
          if (this.showRecord && this.showRecord.indexOf(c.id) !== -1) {
            let list = this.getCityByParentId(c.id);
            let res = list.then((e) => {
              c.children = e;
              if (c.children && c.children.length > 0) {
                c.children.map(d => {
                  // 若存在，展开对应的行
                  if (this.showRecord && this.showRecord.indexOf(d.id) !== -1) {
                    let list = this.getCityByParentId(d.id);
                    let res = list.then((e) => {
                      d.children = e;
                    })
                    d._showChildren = true;
                  } else {
                    d._showChildren = false;
                  }
                })
              }
            })
            c._showChildren = true;
          } else {
            c._showChildren = false;
          }
        });
        console.log(listData);
        this.list = listData;
      }
    },
    async getCityByParentId(id) {
      let res = await this.getCity2(id);
      return res;
    },
    async delItem(item) { 
      let result = await this.delCity(item.id);
      if (result.successed) {
        this.$Message.success("删除成功");
        this.init();
      } else {
        this.$Message.error("删除失败，请重新尝试");
      }
    },
    async handleLoadData(item, callback) {
      let list = await this.getCity2(item.id);
      if (list && list.length > 0) {
        callback(list);
      } else {
        this.$Message.success("暂无数据");
        callback([]);
      }
    },
    showAdd() { // 新增
      this.show = true;
      this.modelTitle = '新增省级';
      this.options = {
        model:null,
        msg:null,
      }
    },
    editShow(item) { // 编辑
      this.show = true;
      this.modelTitle = '编辑';
      this.options = {
        model:'edit',
        msg:item,
      }
    },
    editSubShow(item) {
      this.showChild = true;
      this.modelTitle = '新增市级';
      this.optionsChild = {
        model:'edit',
        msg:item,
      }
    },
    editSubShow2(item) {
      this.showChild2 = true;
      this.modelTitle = '新增区/县级';
      this.optionsChild2 = {
        model:'edit',
        msg:item,
      }
    }
  }
};
</script>

<style lang="scss" scoped>
.common-ad {
  .header-switch {
    display: flex;
    align-items: center;
    padding: 0 35px 18px 35px;
    background: #fff;
    &-text {
      flex: 1;
      font-size: 14px;
      color: #808080;
    }
    &-box {
      flex: 1;
      text-align: right;
    }
  }
  .custom-wrap {
    margin: 0 auto;
    min-height: 500px;
  }
}
</style>